module.exports = __webpack_public_path__ + "static/media/sign-in-bg-1440.a662880f.jpg";